"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _path = _interopRequireDefault(require("../../helpers/path"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _CryptoNavItemsContainer = _interopRequireDefault(require("../WalletNavItems/CryptoNavItemsContainer"));
var _FiatNavItemsContainer = _interopRequireDefault(require("../WalletNavItems/FiatNavItemsContainer"));
var _numberFormatter = require("../../helpers/numberFormatter");
var _resize = _interopRequireDefault(require("../../hocs/resize"));
require("./WalletCard.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var walletCardClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-card');
var WalletCard = function WalletCard(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  var iconFileName = props.iconFileName,
    ProductSymbol = props.ProductSymbol,
    ProductFullName = props.ProductFullName,
    Amount = props.Amount,
    rawAmount = props.rawAmount,
    isCrypto = props.isCrypto,
    ProductId = props.ProductId,
    productColor = props.productColor,
    baseCurrency = props.baseCurrency,
    width = props.width,
    NotionalValue = props.NotionalValue,
    NotionalProductSymbol = props.NotionalProductSymbol,
    showNotionalValue = props.showNotionalValue,
    isWithdrawAllowed = props.isWithdrawAllowed,
    isDepositAllowed = props.isDepositAllowed;
  var iconSize = width > 1024 ? 44 : 28;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(walletCardClasses(), " container-with-shadow")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('icon-label-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      borderTop: "4px solid ".concat(productColor)
    },
    className: walletCardClasses('icon')
  }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    iconFileName: iconFileName,
    size: iconSize
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: walletCardClasses('symbol-label')
  }, "".concat(ProductSymbol, " ").concat(ProductFullName))), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('balance-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('balance')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: walletCardClasses('label')
  }, t("Current Balance")), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('amount')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: walletCardClasses('amount-text')
  }, Amount))), showNotionalValue ? /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('balance')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: walletCardClasses('label')
  }, "Notional Value"), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('amount-text')
  }, (0, _numberFormatter.formatNumberToLocale)(NotionalValue, NotionalProductSymbol))) : baseCurrency ? /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('balance')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: walletCardClasses('label')
  }, baseCurrency.product, " ", t("Value")), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('amount')
  }, (0, _numberFormatter.formatNumberToLocale)(rawAmount * baseCurrency.value, baseCurrency.DecimalPlaces))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('activity-link-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('activity-link-container')
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: walletCardClasses('activity-link'),
    to: (0, _path["default"])(props.detailsLink),
    onClick: props.selectPositionAndSave
  }, t("Details"), ' ', /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "arrowNext",
    customClass: walletCardClasses('next-icon')
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: walletCardClasses('icon-nav-buttons')
  }, isCrypto ? /*#__PURE__*/_react["default"].createElement(_CryptoNavItemsContainer["default"], {
    product: {
      iconFileName: iconFileName,
      ProductSymbol: ProductSymbol,
      ProductFullName: ProductFullName,
      ProductId: ProductId,
      isWithdrawAllowed: isWithdrawAllowed,
      isDepositAllowed: isDepositAllowed
    },
    showIconButtonLabel: false
  }) : /*#__PURE__*/_react["default"].createElement(_FiatNavItemsContainer["default"], {
    product: {
      iconFileName: iconFileName,
      ProductSymbol: ProductSymbol,
      ProductFullName: ProductFullName,
      ProductId: ProductId,
      isWithdrawAllowed: isWithdrawAllowed,
      isDepositAllowed: isDepositAllowed
    },
    showIconButtonLabel: false
  }))));
};
var _default = exports["default"] = (0, _resize["default"])(WalletCard);